import { createQueryKeys } from '@lukemorales/query-key-factory'

import store from '~/redux'

import { dynamicLinkService } from '../services/dynamic-link.service'
import type { ListDynamicLinksInput } from '../types/list-dynamic-links-input.type'

const userId = store.getState().user?.id

export const dynamicLinksQueries = createQueryKeys('dynamicLinks', {
  list: (input: ListDynamicLinksInput) => ({
    queryKey: [input, { userId }],
    queryFn: async () => await dynamicLinkService.listDynamicLinks(input),
  }),
})
